module.exports = __webpack_public_path__ + "static/bilingual@large-db29cf3fe2f8832c5ce30781821323ab.jpg";